export default __webpack_public_path__ + "static/studyoffice-office2-5573a2a78e26647e9535cc1fbe1b3fba.jpg";